import React, { useState } from 'react';

const Filter = ({ title, options, defaultValue, current = null, handler }) => {
  const [hidden, setHidden] = useState(true);
  return (
    <div className={'insights-scroller__filter insights-scroller__filter-' + title.toLowerCase().replaceAll(' ','-') }>
      <button className="filter__title" onClick={() => setHidden(!hidden)}>
        Filter by {title}
      </button>
      <ul className={hidden ? 'hidden' : ''}>
        <li key={`${title} Default`}>
          <button
            className={current === null ? 'active' : undefined}
            onClick={() => {
              setHidden(true);
              handler(null);
            }}
          >
            {defaultValue}
          </button>
        </li>
        {options.map(({ id, title }) => (
          <li key={`${title} ${id}`}>
            <button
              className={current === id ? 'active' : undefined}
              dangerouslySetInnerHTML={{ __html: title }}
              onClick={() => {
                setHidden(true);
                handler(id);
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Filter;
